type ContactRecord = Record<string, unknown>;

const CONTACT_FIELDS = [
    "is_default",
    "name",
    "email",
    "phone",
    "position",
] as const;

const parseContactValue = (value: unknown): unknown => {
    if (typeof value !== "string") {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch {
        return [];
    }
};

export const normalizeProviderContactList = (value: unknown): any[] => {
    const parsedValue = parseContactValue(value);
    let candidates: unknown[];

    if (Array.isArray(parsedValue)) {
        candidates = parsedValue;
    } else if (parsedValue && typeof parsedValue === "object") {
        const record = parsedValue as ContactRecord;
        const isContact = "contact" in record ||
            CONTACT_FIELDS.some((field) => field in record);

        if (isContact) {
            candidates = [record];
        } else {
            const values = Object.values(record);
            candidates = values.length > 0 &&
                values.every((item) => item && typeof item === "object")
                ? values
                : [];
        }
    } else {
        candidates = [];
    }

    return candidates.flatMap((candidate, index) => {
        if (!candidate || typeof candidate !== "object") {
            return [];
        }

        const record = candidate as ContactRecord;
        const nestedContact = record.contact;
        const contact = nestedContact && typeof nestedContact === "object"
            ? nestedContact as ContactRecord
            : record;

        return [{
            id: record.id ?? index + 1,
            contact: {
                is_default: Boolean(contact.is_default),
                name: contact.name ?? "",
                email: contact.email ?? "",
                phone: contact.phone ?? "",
                position: contact.position ?? "",
            },
        }];
    });
};
